import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {RoboadvChatComponent} from "./roboadv-chat/roboadv-chat.component";
import {HomeComponent} from "./home/home.component";
import {ThxComponent} from "./thx/thx.component";
import {Err404Component} from "./err404/err404.component";
import {ErrAllComponent} from "./err-all/err-all.component";
import {SurveyComponent} from "./survey/survey.component";

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'roboadv-chat', component: RoboadvChatComponent },
  { path: 'survey', component: SurveyComponent },
  { path: 'thx/:type', component: ThxComponent },
  { path: 'err-404', component: Err404Component },
  { path: 'err-all', component: ErrAllComponent },
  { path: '', redirectTo: "/home", pathMatch:'full' },
  { path: '**', redirectTo: "/err-404" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
